import { BaseService } from './../base'

export class Document_DistributionService extends BaseService {
  static get entity () {
    return 'document_distribution'
  }
  static get name () {
    return 'document_distribution'
  }
}